import { render, staticRenderFns } from "./CommonVideoCG.vue?vue&type=template&id=6bac2df9&scoped=true"
import script from "./CommonVideoCG.vue?vue&type=script&lang=js"
export * from "./CommonVideoCG.vue?vue&type=script&lang=js"
import style0 from "./CommonVideoCG.vue?vue&type=style&index=0&id=6bac2df9&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bac2df9",
  null
  
)

export default component.exports